import { ChatInfoModalActionType } from '../../types/chatInfoModalType'

export const changeChatInfoModal = () => {
    return {type: ChatInfoModalActionType.CHANGE_CHAT_INFO_MODAL}
}

export const closeChatInfoModal = () => {
    return {type: ChatInfoModalActionType.CLOSE_CHAT_INFO_MODAL}
}